import { Locales } from "@simplyk/common";

import { getReferencedPaymentId } from "./paymentReference";

import { trpc } from "@/common/helpers/trpc";
import { AssistantChatTransportOptions, createTrpcChatTransport } from "@/features/Assistant/helpers/trpcChatTransport";

type TrpcClient = ReturnType<typeof trpc.useUtils>["client"];

interface DonorStreamContext {
  locale: Locales;
}

interface DonorMessageTurnExtras {
  paymentId?: string;
}

export const createDonorAssistantTransport = (
  client: TrpcClient,
  options: Omit<AssistantChatTransportOptions<DonorStreamContext, DonorMessageTurnExtras>, "getMessageTurnExtras">
) =>
  createTrpcChatTransport<DonorStreamContext, DonorMessageTurnExtras>(
    {
      send: (input) => client.sendDonorAssistantMessage.mutate(input),
      stream: (input, handlers) => client.streamDonorAssistantTurn.subscribe(input, handlers),
      getConversation: (input) => client.getDonorAssistantConversation.query(input),
      cancel: (input) => client.cancelDonorAssistantTurn.mutate(input),
    },
    { ...options, getMessageTurnExtras: (message) => ({ paymentId: getReferencedPaymentId(message) ?? undefined }) }
  );
